export default __webpack_public_path__ + "e0c5340139f561cf7610d96f1c4008a8.gif";